export function isLogin() {
	return localStorage.getItem('access_token');
}

export function kakaoInit() {
	if (window.Kakao.Auth === undefined) {
		window.Kakao.init(import.meta.env.VITE_KAKAO_JAVASCRIPT_API_KEY);
	}
}

export async function appleLogin() {
	window.AppleID.auth.init({
		clientId: `${import.meta.env.VITE_APPLE_CLIENT_ID}`,
		scope: 'name email',
		redirectURI: `${import.meta.env.VITE_APPLE_REDIRECT_URI}`,
		responseType: 'code',
		usePopup: true,
	});

	const res = await window.AppleID.auth.signIn();
	window.location.replace(`/apple/redirect?code=${res.authorization.code}`);
}

export function googleLogin() {
	window.location.replace(
		`https://accounts.google.com/o/oauth2/v2/auth?client_id=${import.meta.env.VITE_GOOGLE_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_GOOGLE_REDIRECT_URI}&response_type=code&scope=email+profile`,
	);
}

export function naverLogin() {
	window.location.replace(
		`https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${import.meta.env.VITE_NAVER_CLIENT_ID}&state=${import.meta.env.VITE_NAVER_STATE}&redirect_uri=${import.meta.env.VITE_NAVER_REDIRECT_URI}`,
	);
}

export async function kakaoLogin() {
	window.Kakao.Auth.authorize({
		redirectUri: import.meta.env.VITE_KAKAO_REDIRECT_URI,
	});
}

export function logout() {
	localStorage.removeItem('access_token');
}
